import { Alert, Button, Card, Form, Input, Typography, Space, Divider } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined, GithubOutlined, GoogleOutlined } from "@ant-design/icons";
import React from "react";

const { Title, Text } = Typography;

export const AuthForm = ({ submit, errorMessage, loading }) => {
    const onFinish = (values) => {
        submit(values);
    };

    const onFinishFailed = (errorInfo) => {
        // Обработка неудачной отправки формы
    };

    return (
        <div style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 100%)",
            padding: "20px"
        }}>
            <Card
                style={{
                    width: "100%",
                    maxWidth: 440,
                    borderRadius: 12,
                    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.5)",
                    overflow: "hidden",
                    background: "#1a1a1a",
                    border: "1px solid #303030"
                }}
                styles={{ body: { padding: "32px" } }}
            >
                <Space direction="vertical" size="middle" style={{ width: "100%", textAlign: "center", marginBottom: 24 }}>
                    <div style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #52c41a 0%, #1890ff 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto"
                    }}>
                        <LoginOutlined style={{ fontSize: 28, color: "#fff" }} />
                    </div>
                    <Title level={3} style={{ margin: 0, color: "#f0f0f0" }}>Авторизация</Title>
                    <Text type="secondary" style={{ color: "#8a8a8a" }}>Введите свои учетные данные для входа в систему</Text>
                </Space>

                <Form
                    name="login"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        label={<span style={{ color: "#d9d9d9" }}>Логин</span>}
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Пожалуйста, введите имя пользователя!',
                            },
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined style={{ color: "#8a8a8a" }} />}
                            placeholder="Введите ваш логин"
                            style={{
                                background: "#141414",
                                border: "1px solid #303030",
                                color: "#f0f0f0"
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#d9d9d9" }}>Пароль</span>}
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Пожалуйста, введите пароль!',
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{ color: "#8a8a8a" }} />}
                            placeholder="Введите ваш пароль"
                            style={{
                                background: "#141414",
                                border: "1px solid #303030",
                                color: "#f0f0f0"
                            }}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            style={{
                                width: "100%",
                                height: 45,
                                background: "linear-gradient(135deg, #52c41a 0%, #1890ff 100%)",
                                border: "none",
                                borderRadius: 6,
                                fontWeight: 600,
                                fontSize: 16
                            }}
                            size="large"
                        >
                            Войти
                        </Button>
                    </Form.Item>
                </Form>

{/*                <Divider style={{ color: "#5a5a5a", borderColor: "#303030" }}>или</Divider>

                <Space direction="vertical" style={{ width: "100%" }}>
                    <Button
                        icon={<GoogleOutlined />}
                        style={{ width: "100%", background: "#141414", borderColor: "#303030", color: "#f0f0f0" }}
                        size="large"
                    >
                        Войти через Google
                    </Button>
                    <Button
                        icon={<GithubOutlined />}
                        style={{ width: "100%", background: "#141414", borderColor: "#303030", color: "#f0f0f0" }}
                        size="large"
                    >
                        Войти через GitHub
                    </Button>
                </Space>*/}

                {errorMessage && (
                    <Alert
                        message={errorMessage}
                        type="error"
                        showIcon
                        closable
                        style={{
                            marginTop: 16,
                            background: "#2a1215",
                            border: "1px solid #58181c",
                            color: "#f0f0f0"
                        }}
                    />
                )}
            </Card>
        </div>
    );
};